import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import { http, HttpResponse } from 'msw'

export const deleteFamilyMember = http.delete<{ familyMembersId: string }>(
  apiBaseUrl + '/familyMembers/:familyMembersId',
  async () => {
    const status = 200
    return new HttpResponse(JSON.stringify({ status: status }), {
      status: status,
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
)
